import React from 'react';
import EnquiryForm from './EnquiryForm';

const tourData = [
  // {
  //   title: "Hatchback",
  //   image: "/images/booking/hatchback.jpg",
  //   seater: "4+1 (Driver)",
  //   driverAllowance: "₹500",
  //   perKm: "₹12",
  //   extraHr: "₹150",
  //   nightHalt: "₹250",
  // },
  {
    title: "Sedan",
    image: "/images/resource/dezire.png",
    seater: "4+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹17",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  // {
  //   title: "Ertiga",
  //   image: "/images/booking/ertiga.jpg",
  //   seater: "6+1 (Driver)",
  //   driverAllowance: "₹500",
  //   perKm: "₹15",
  //   extraHr: "₹150",
  //   nightHalt: "₹250",
  // },
  // {
  //   title: "Innova Cab",
  //   image: "/images/booking/suv.jpg",
  //   seater: "6+1 (Driver)",
  //   driverAllowance: "₹500",
  //   perKm: "₹18",
  //   extraHr: "₹150",
  //   nightHalt: "₹250",
  // },
  {
    title: "Innova Crysta",
    image: "/images/booking/innova-crysta.jpg",
    seater: "6+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹20",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Tempo Traveller",
    image: "/images/booking/Tempo.jpg",
    seater: "13+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Mini Bus",
    image: "/images/resource/minibus.png",
    seater: "32+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹25",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Bus",
    image: "/images/resource/9.jpg",
    seater: "50+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹35",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
    {
    title: "Volvo Bus",
    image: "/images/resource/volvo.jpg",
    seater: "52+1 (Driver)",
    driverAllowance: "₹500",
    perKm: "₹35",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
];


const Booking = () => {
  const handleBookNow = (tourTitle) => {
    const phoneNumber = "+919356411908";
    const message = `I want to Book ${tourTitle} With etravo. Request you Please Send More Details or Call Me. Thank you. `;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  

  return (
    <>
       <section
      className="page-title"
      style={{ backgroundImage: 'url(images/background/3.jpg)' }}
    >
      <div className="auto-container">
        <h1>Online Booking</h1>
        <div className="bread-crumb-outer">
         
        </div>
      </div>
    </section>

      <EnquiryForm/>

      <section className="space">
        <div className="container">
          <div className="row">
            {tourData.map((tour, index) => (
              <div key={index} className="col-md-4 py-4">
                <div className="tour-box th-ani">
                  <div className="tour-box_img global-img ">
                    <img src={tour.image} alt={tour.title} />
                  </div>
                  <div className="tour-content bg-darkk">
                    <h3 className="box-title">
                      <h4 href={tour.detailLink} className="darkcolor text-center text-white">{tour.title}</h4>
                    </h3>
                    <div className="tour-details">
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Seater:</strong></span>
                        <span className="detail-value">{tour.seater.replace('+', ' + ')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Per Km:</strong></span>
                        <span className="detail-value">{tour.perKm.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Extra Hr:</strong></span>
                        <span className="detail-value">{tour.extraHr.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Night Halt:</strong></span>
                        <span className="detail-value">{tour.nightHalt.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                    </div>

                    <div className="tour-action text-center">
                      <button
                        onClick={() => handleBookNow(tour.title)}
                        className="theme-btn  bg-white txtt"
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
